import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { useGetWorkOrderBomListQuery, useGetWorkOrderItemListQuery } from '../../../../store/api/assemblyapi';
import ApiSelectSearch from '../../../../Core/Fields/Floating/ApiSelectSearch';

const Tab1 = ({ WOI,WOBOM,qty, podate, ponumber }) => {
  const {data:Bomdata} = useGetWorkOrderBomListQuery(WOI.selectWOItem)


  return (
    <div className="row sidebarbox m-0 d-flex flex-column" style={{ padding: "8px", borderRadius: "5px",height: '72vh', overflowY: 'scroll',flexWrap:'nowrap'}}>
     
       <div className="col-12">
      <div className="row">
      <div className="col-md-6 mt-1 mb-2" >
        <Input id="orderNo" label="No." readOnly value={ponumber} style={{ height: '30px' }} />
      </div>
      <div className="col-md-6 mt-1">
        <Input id="orderdatepo" type="date" style={{ height: '30px' }} label="Date" readOnly value={podate.podate} onChange={(e) => podate.setpodate(e.target.value)} />
      </div>
      </div>
      </div>
      <div className="col-12 ">
        <div className={WOI?.Error ? `mb-3 errorborder` : `mb-3`}>
        <Input id="orderdatepo" type="text" style={{ height: '30px' }} label="Item To Manufacture" readOnly value={WOI.selectWOItem} onChange={(e) => podate.setpodate(e.target.value)} />
        </div>
      </div>
      <div className="col-12 ">
        <div className={WOBOM.Error ? `mb-3 errorborder` : `mb-3`}>
        <Input id="orderdatepo" type="text" style={{ height: '30px' }} label="BOM No." readOnly value={WOI.selectWOItem} onChange={(e) => podate.setpodate(e.target.value)} />
        </div>
      </div>
      <div className="col-12 ">
        <Input id="orderdatepo" type="number" readOnly style={{ height: '30px',border:qty.Error ? "1px solid red" : '' }} label="Qty To Manufacture" value={qty.QtyToManufacture} onChange={(e) => qty.setQtyToManufacture(e.target.value)} />
        
      </div>
    


    </div>
  )
}

export default Tab1